// Modal Provider
export {ModalProvider, default as GlobalModalProvider} from './ModalProvider';

// Modal Components
export {ConfirmationModal} from './ConfirmationModal';
export {AlertModal} from './AlertModal';
export {UnAuthenticatedUserModal} from './UnAuthenticatedUserModal';
export {AboutPaymentOptionModal} from './AboutPaymentOptionModal';
export {KmpDeactivationModal} from './KmpDeactivationModal';
export {KeyTermsSheet} from './KeyTermsSheet';

// Types
export type {
    ModalConfig,
    ModalOptions,
    ModalSize,
    ConfirmationModalProps,
    AlertModalProps,
    KmpDeactivationModalProps,
    KeyTermsSheetModalProps
} from '@/presentation/stores/ModalStore';

export type { KeyTermsSheetProps } from './KeyTermsSheet';

// Store
export {ModalStore} from '@/presentation/stores/ModalStore';

// Hooks
export {useModalStore} from '@/presentation/hooks/useStores';